import React, { useState } from 'react'
import './take-action.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { accountingAxios } from '../../../config/axios'
import { useParams } from 'react-router-dom'

const TakeAction = ({ actionStatus, setData, setModal }) => {
    const { prospect_id } = useParams()
    const [comment, setComment] = useState('')

    const handleTackAction = (e) => {
        e.preventDefault();

        accountingAxios.post('/sales/bills/action', {
            prospect_id,
            action_type: actionStatus,
            comment
        }).then(() => {
            setData((state) => ({
                ...state,
                bills_status: Number(actionStatus),
                bills_comment: comment,
                bills_action_date: new Date()
            }))

            setModal({ status: false })
        })
    }

    return (
        <div className="take-action-comp-div">
            {actionStatus === 1 && <>
                <form onSubmit={handleTackAction}>
                    <div className="border-div">
                        <p>Are you sure you want to confirm this bill and quotation?
                            Once accepted, the accounting team will take responsibility
                            for proper handling and finalization.</p>
                        <button className='green'>Yes, I understand.</button>
                    </div>
                </form>
            </>}
            {actionStatus === 2 && <>
                <form onSubmit={handleTackAction}>
                    <div className="border-div">
                        <p>Are you sure you want to reject this request? Once rejected,
                            the accounting team will take responsibility for updating records
                            and taking necessary action. The prospect's status will remain as
                            'Pending for Approval.' Please provide a reason for rejection.</p>
                        <NormalInput label='Reason' name='comment' onChangeFun={(e) => setComment(e.target.value)} value={comment} />
                        <button className='red'>Yes, I understand.</button>
                    </div>
                </form>
            </>}
        </div>
    )
}

export default TakeAction